module.exports = __webpack_public_path__ + "static/img/zhubo5.b32fed84.jpg";